import script from "./InfoVoteTable.vue?vue&type=script&setup=true&async=true&lang=js"
export * from "./InfoVoteTable.vue?vue&type=script&setup=true&async=true&lang=js"

import "./InfoVoteTable.vue?vue&type=style&index=0&id=b4607490&lang=css"
import "./InfoVoteTable.vue?vue&type=style&index=1&id=b4607490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4607490"]])

export default __exports__